<sl-details [open]="open" [summary]="summary">
  <ng-content></ng-content>
</sl-details>
